module.exports = __webpack_public_path__ + "img/wateranimation_lesswater.77dc91b3.gif";